import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { TaskStatusType } from 'api/status-updates';
import { TaskType } from 'api/tasks';
import {
  updateDocResource,
  selectDocumentResourceSections,
  selectActiveDocumentInfo,
} from 'data/documents';
import { selectActiveStatusUpdate } from 'data/status-updates';
import styles from './draggable.module.css';

interface Props {
  resourceIds: number[];
  resourceObjects?:
    | {
        [key: string]: any;
      }[]
    | undefined;
  commandName: string;
  commandOptions?: {
    [key: string]: any;
  };
}

export const Draggable: FC<Props> = ({
  children,
  resourceIds,
  resourceObjects,
  commandName,
  commandOptions = {},
}) => {
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);
  const documentResources = useSelector(selectDocumentResourceSections);
  const activeDocumentDetails = useSelector(selectActiveDocumentInfo);

  const getResourceObjects = () => {
    // store resourceObjects in API only when needed.
    // in our case, we don't have to store task and milestone objects in api
    // as that we can get easily from Ids. But for approvals, we need
    // to store it in the api.
    return commandOptions.type !== TaskType.Task &&
      commandOptions.type !== TaskType.Milestone
      ? resourceObjects
      : undefined;
  };

  return (
    <div
      className={styles.draggable}
      draggable="true"
      onDragStart={(event) => {
        const resourceSectionId = Number(new Date());
        const dropEventPayload = {
          projectID: activeStatusUpdate?.project.projectId,
          documentID: activeStatusUpdate?.document.documentId,
          documentSectionId: activeDocumentDetails.publicSection.id,
          sectionType: 'PUBLIC',
          resourceSections: [
            {
              resourceSectionId,
              resourceIds,
              resourceSectionType:
                commandOptions.resourceSectionType || TaskType.Task,
              resourceObjects: getResourceObjects(),
            },
            ...documentResources,
          ],
        };

        event.dataTransfer.setData(
          'application/json',
          `{
              "ckWidgetCommandName": "${commandName}",
              "ckWidgetCommandOptions": ${JSON.stringify(commandOptions)},
              "event": {
                "payload": ${JSON.stringify(dropEventPayload)},
                "type": "${updateDocResource.type}"
              },
              "options": {
                "resourceSectionId": "${resourceSectionId}",
                "resourceSectionType": "${
                  commandOptions.type || TaskType.Task
                }",
                "resourceSectionFilterType": "${
                  commandOptions.resourceSectionFilterType ||
                  TaskStatusType.Completed
                }",
                "resourceSectionFilterRange": "${
                  commandOptions.resourceSectionFilterRange
                }",
                "resourceIds": [${resourceIds}]
              }
            }`,
        );
      }}
    >
      {children}
    </div>
  );
};
